import React from "react";

export default function CandidateMatchRanking() {
  return <div>CandidateMatchRanking</div>;
}
